import { HttpClient } from '@angular/common/http';
import { TranslateLoader } from '@ngx-translate/core';
import { forkJoin } from 'rxjs';
import { map } from 'rxjs/operators';

export class MultiTranslateHttpService implements TranslateLoader {

    constructor(private http: HttpClient, public resources: { prefix: string, suffix: string }[]) {
    }

    public getTranslation(lang: string): any {
        return forkJoin(this.resources.map(config => this.http.get(`${config.prefix}${lang}${config.suffix}`)))
            .pipe(map(response => response.reduce((a, b) => Object.assign(a, b))));
    }
}
